import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/common/Loader";

export function ProtectedRoute({ role, children }) {
  const { user, ready } = useAuth();
  if (!ready || user === null) return <Loader full label="Preparing your studio" />;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "super_admin" ? "/superadmin" : "/app"} replace />;
  }
  return children;
}
